import React, { Component } from 'react';
import axios from 'axios';
import ScrollReveal from 'scrollreveal';
var $ = require('jquery');

export default class Homepage extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    //this.getBlogPosts();
    function l(o) { console.log(o) }
    $(document).ready(function () {
      setTimeout(function () {
        $('.section-1 .section-content').addClass('activeSection');
      }, 700);

      var sections = $('.box').toArray();
      var scroll = {
        activeSection: 0,
        sectionCount: sections.length - 1,
        isThrottled: false,
        throttleDuration: 1200,
        target: $(sections[0]).position().top
      }

      function downSection() {
        var nextLeft = window.innerWidth;
        $("body").animate({ "marginLeft": -nextLeft * (scroll.activeSection + 1) }, 500);
        $('header ul li').removeClass('active');
        $('header ul li:nth-of-type(' + (scroll.activeSection + 2) + ')').addClass('active');
        ++scroll.activeSection;
        setTimeout(function () {
          $('.section-' + (scroll.activeSection + 1) + ' .section-content').addClass('activeSection');
        }, 500);
        return false;
      }

      function upSection() {
        var nextLeft = window.innerWidth;
        $("body").animate({ "marginLeft": -nextLeft * (scroll.activeSection - 1) }, 500);
        $('header ul li').removeClass('active');
        $('header ul li:nth-of-type(' + scroll.activeSection + ')').addClass('active');
        --scroll.activeSection;
        setTimeout(function () {
          $('.section-' + (scroll.activeSection + 1) + ' .section-content').addClass('activeSection');
        }, 500);
        return false;
      }

      $('header ul li').on({
        'click': function () {
          console.log($(this).attr('data-section'));
          scroll.activeSection = $(this).attr('data-section');
        }
      });

      $(window).on('scroll', function (e) {
        if (window.innerWidth > 1019) {
          e.preventDefault();
          return false;
        }

      });

      $(window).on('mousewheel', function (event) {
        if (window.innerWidth > 1020) {
          event.preventDefault();

          if (scroll.isThrottled) { return; }
          scroll.isThrottled = true;

          setTimeout(function () {
            scroll.isThrottled = false;
          }, scroll.throttleDuration);

          if (event.originalEvent.wheelDelta > 0) {
            if (scroll.activeSection === 0) return false;
            upSection();
          } else {
            if (scroll.activeSection >= scroll.sectionCount) return false;
            downSection();

          }
        }
      });


      $(window).keydown(function (e) {
        if (e.keyCode == 40 && (scroll.activeSection != sections.length - 1)) {
          downSection();
          l('ARROW DOWN');
        } else if (e.keyCode == 38 && (scroll.activeSection != 0)) {
          upSection();
          l('ARROW UP');
        }
      });
    });

    if (window.innerWidth < 1021) {
      window.sr = ScrollReveal();
      window.sr.reveal('.section-content h2, .section-content div');
    }

  }
  render() {
    return (
      <div className="section-container">

        <div className="box section section-1">
          <div className="section-content">
            <div className="button-container">
              <a href="/facials"><div className="button">Facials</div></a>
              <a href="/microderm"><div className="button">Microdermabrasion</div></a>
              <a href="/chemical"><div className="button">Chemical Peels</div></a>
              <a href="/microcurrent"><div className="button">Microcurrent</div></a>
              <a href="/oncology"><div className="button">Oncology</div></a>
              <a href="/waxing"><div className="button">Mens Waxing</div></a>
              <a href="/membership"><div className="button">Subscription</div></a>
              <a href="https://squareup.com/appointments/book/8TRZBE87549SM/integrity-skin"><div className="button">Book Appointment</div></a>
            </div>
          </div>
        </div>

        <div className="box section section-2">
          <div className="section-content">
            <h1>About</h1>
            <div>
              <p>Integrity Skincare is a multiple award-winning skincare studio based in San Francisco focusing on the simple objective of skin care solutions and results.</p>
              <p>We are a private, single-treatment practice specializing in medical grade skin care, acne treatment, chemical exfoliation, microdermabrasion, and mens waxing.</p>
              <p>Additionally we are licensed and trained to work with oncology patients who are pre-treatment, in-treatment, and post-treatment.</p>
              <p>Integrity Skincare utilizes the use of pure botanical oils and also carries the medical grade product lines of Image and Lira.</p>
              <p>Our goal to ensure every client’s skin is nourished, youthful, radiant and has a natural appearance.</p>
              <p>Our mission is to give you the best skin care treatments, education, and customer service.</p>
              <p>Brandon Doyle is the founder of Integrity Skincare, a fully licensed award-winning medical esthetics practice for advanced skincare located at the base of San Francisco's Financial District.</p>
              <p>He has received his post-graduate advanced esthetics training from the top educators in the dermatology/esthetics field and continues his education through annual conferences, research journals, and advanced coursework to ensure his clients are given thoroughly researched and up-to-the-minute treatments.</p>
              <p>Named <strong>'Best Skincare Studio'</strong> in San Francisco two years in a row, Integrity Skincare specializes in the the unique needs of the professional client with the expressed goal of solving your skincare concerns and maintaining your skin's health and appearance.</p>
              <p>The utilization of non-invasive, cutting-edge treatments and a keen, discerning﻿ eye allow Brandon to rectify the aging process with natural appearing results. But according to his clients, it is Brandon's genuine demeanor, knowledge, and skill that make him one of the West Coast's most sought after Medical Esthetic practitioners.</p>
            </div>
          </div>
        </div>


        <div className="box section section-3">
          <div className="section-content">
            <h1>Reviews</h1>

            <div>
              <p>I thought I would have to wait for at least a couple of days to review this place until my skin calms down, but wow! I decided to go for the Deep Renewal Facial since I have problematic skin and my face started breaking out. Brandon was really nice and didn't push any products on me. He did extractions, 4 layer facial and finally a round of high frequency treatment. My face was a bit red, as expected after extractions but this morning I woke up with amazing, smooth skin and all of my acne were dried out from the treatment and skin was without any redness. Thank you Brandon!<strong> -Svetlana R.</strong></p>

              <p>Found Integrity Skincare through a friend who highly recommended Brandon and am really glad I did. Not really too comfortable getting waxed and "groomed" but his studio is very private and the session is one-on-one without anybody walking in and out, or talking 10 ft away. He's quick with the waxing (my girlfriend is much happier) and really spent the time to make sure I was well taken care of. Plus he's a nice guy, so there's that too.</p>
              <p>Last visit I changed it up and had a really relaxing back treatment "facial" and hate to say it but I fell asleep... maybe that was the point...<strong><br />-Britt F.</strong></p>


              <p>I made an appointment with Brandon for waxing services. He uses an expensive, higher quality of wax not made from tree sap (think turpentine) like most waxing places. He was detail oriented and my skin was barely pink after the waxing. Within 2-3 hours my skin was perfectly clear and smooth. Don't settle for second rate wax or someone who doesn't care. This is a wonderful experience. Treat yourself-you won't go anywhere else. <strong>-John B.</strong></p>

              <a href="https://www.yelp.com/biz/integrity-skin-care-san-francisco" target="blank"><div className="button">Read More on Yelp <i className="fab fa-yelp"></i></div></a>
            </div>
          </div>
        </div>



        <div className="box section section-4">
          <div className="section-content">
            <h1>Contact Us</h1><br />

            <div>
              <h2>546 Fillmore St.<br />
                San Francisco, CA 94117<br />
                415-501-0360</h2>

            </div>
          </div>
        </div>

      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/_templates/Homepage.jsx